export const SET_RECALL_SERVICES = 'SET_RECALL_SERVICES';
export const SET_DEFERRED_SERVICES = 'SET_DEFERRED_SERVICES';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';



// WEBPACK FOOTER //
// ./src/store/reducers/recall/actionTypes.js